import { render } from "./UVIndex.vue?vue&type=template&id=c7e13db4&scoped=true"
import script from "./UVIndex.vue?vue&type=script&lang=js"
export * from "./UVIndex.vue?vue&type=script&lang=js"

import "./UVIndex.vue?vue&type=style&index=0&id=c7e13db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7e13db4"]])

export default __exports__